import { auth0Error } from '../copy/landing';

/**
 * Auth0's code and reason, from whichever error the SDK handed over. A refused redirect
 * arrives as auth0-spa-js's AuthenticationError and auth0-react's own as an OAuthError;
 * both carry `error` and `error_description`, and auth0Error knows the fix for the two a
 * person actually hits. Anything else is named by its own name and message.
 *
 * Read by field, never by class: `instanceof OAuthError` misses the AuthenticationError
 * that a refused redirect actually is, and would print its description with no code.
 */
export function auth0Line(error: Error): string {
  if (!('error' in error) || typeof error.error !== 'string') return auth0Error(error.name, error.message);
  const code = error.error;
  // auth0-spa-js fills a missing description with the code, which is no reason at all.
  const reason =
    'error_description' in error && typeof error.error_description === 'string' && error.error_description !== code
      ? error.error_description
      : null;
  return auth0Error(code, reason);
}
